import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import i18n from "./i18n";
import { useTranslation } from "react-i18next";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang && savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    if (!email) {
      setError(t("inserisciEmailErrore"));
      setLoading(false);
      return;
    }

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: "https://app.carbozen.it/reset-password",
    });

    if (error) {
      setError(error.message);
    } else {
      setMessage(t("emailInviataMessaggio"));
    }

    setLoading(false);
  };

  return (
    <div className="container">
      <a href="https://carbozen.it">
        <img src="/logo.png" alt="CarboZen Logo" className="logo-image" />
      </a>

      <div className="card-section card-green auth-card" style={{ textAlign: "center" }}>
        <h2 className="titlesec">{t("passwordDimenticataTitolo")}</h2>
        <p className="instructions">{t("passwordDimenticataIstruzioni")}</p>

        <form onSubmit={handleSubmit}>
          <label className="form-label">
            <div className="input-wrapper">
              <input
                type="email"
                placeholder={t("email1")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="glicemia-input2"
              />
            </div>
          </label>

          <div className="wizard-buttons">
            <button type="submit" className="custom-button" disabled={loading}>
              {loading ? t("invioInCorso") : t("inviaEmail")}
            </button>
          </div>
        </form>

        {message && (
          <p style={{ color: "green", marginTop: "1rem" }}>{message}</p>
        )}
        {error && <p style={{ color: "red", marginTop: "1rem" }}>{error}</p>}

        <p style={{ marginTop: "1rem", textAlign: "center" }}>
          <a href="/" className="form-label">
            {t("tornaLogin")}
          </a>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
